import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import "./BlogDetail.css";

// Updated Blog images
import b1 from "../assets/Blog_1.jpg";
import b2 from "../assets/Blog_2.jpg";
import b3 from "../assets/Blog_3.jpg";
import b4 from "../assets/Blog_4.jpg";
import b5 from "../assets/Blog_5.jpg";

const BlogDetail = () => {
  useEffect(() => {
    document.title = "Blog Details | Qnexa Services — Engineering & Inspection Specialists";
  }, []);

  const { id } = useParams();

  const blogPosts = {
    1: {
      id: 1,
      title: "The Importance of Third-Party Inspection in Oil & Gas Projects",
      img: b1,
      fullContent: `
        <p>Third-party inspection ensures unbiased quality control and helps reduce project risks...</p>

        <h2>Why Third-Party Inspection?</h2>
        <ul>
          <li>Independent and unbiased assessment</li>
          <li>Ensures safety and compliance</li>
          <li>Enhances reliability and transparency</li>
        </ul>

        <p>It improves overall project quality and ensures long-term operational safety.</p>
      `,
      date: "December 10, 2024",
      author: "Inspection Team",
      category: "Oil & Gas",
      readTime: "4 min read",
    },

    2: {
      id: 2,
      title: "Why Pipeline Integrity Management Matters in 2025",
      img: b2,
      fullContent: `
        <p>Pipeline integrity management is essential to avoid leaks, failures, and downtime...</p>

        <h2>Key Benefits</h2>
        <ul>
          <li>Risk elimination</li>
          <li>Extends asset lifespan</li>
          <li>Regulatory compliance</li>
        </ul>

        <p>Advanced technologies support predictive maintenance for future demands.</p>
      `,
      date: "December 12, 2024",
      author: "Pipeline Experts",
      category: "Engineering",
      readTime: "5 min read",
    },

    3: {
      id: 3,
      title: "How Inspection Digitization Improves Project Efficiency",
      img: b3,
      fullContent: `
        <p>Digital inspection tools enable faster reporting and enhanced visibility...</p>

        <h2>Advantages of Digital Inspection</h2>
        <ul>
          <li>Real-time monitoring</li>
          <li>Paperless documentation</li>
          <li>Error reduction</li>
        </ul>

        <p>It brings transparency and speeds up decision making.</p>
      `,
      date: "December 05, 2024",
      author: "Digital Team",
      category: "Technology",
      readTime: "6 min read",
    },

    4: {
      id: 4,
      title: "The Role of Welding Inspection in Achieving Product Quality",
      img: b4,
      fullContent: `
        <p>Welding inspection ensures joint quality and long-term structural safety...</p>

        <h2>Inspection Methods Used</h2>
        <ul>
          <li>Visual Testing (VT)</li>
          <li>Radiographic Testing (RT)</li>
          <li>Ultrasonic Testing (UT)</li>
        </ul>

        <p>Certified welding inspectors ensure compliance with global standards.</p>
      `,
      date: "November 28, 2024",
      author: "QA/QC Department",
      category: "Quality Control",
      readTime: "7 min read",
    },

    5: {
      id: 5,
      title: "Why Vendor Assessment is Vital Before Procurement",
      img: b5,
      fullContent: `
        <p>Selecting the right vendor reduces failure risks and improves material quality...</p>

        <h2>Vendor Evaluation Factors</h2>
        <ul>
          <li>Technical capability</li>
          <li>Compliance with standards</li>
          <li>Quality history</li>
        </ul>

        <p>Thorough vendor audits ensure long-term trust and success.</p>
      `,
      date: "December 14, 2024",
      author: "Procurement Division",
      category: "Sourcing",
      readTime: "4 min read",
    },
  };

  const post = blogPosts[id];

  if (!post) {
    return (
      <div className="blog-detail-page">
        <div className="blog-not-found">
          <h1>Blog Post Not Found</h1>
          <Link to="/blogs" className="back-to-blogs">Back to Blogs</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-detail-page">

      {/* HEADER */}
      <div className="blog-modern-header">
        <div className="container">
          <Link to="/blogs" className="back-link">← Back</Link>
          <span className="badge">{post.category}</span>
          <h1 className="blog-modern-title">{post.title}</h1>

          <div className="meta-row">
            <span>👤 {post.author}</span>
            <span>📅 {post.date}</span>
            <span>⏱️ {post.readTime}</span>
          </div>
        </div>
      </div>

      {/* BODY */}
      <div className="blog-modern-body">
        <div className="container">
          <div className="featured-image-wrapper">
            <img src={post.img} alt={post.title} className="featured-image" />
          </div>

          <div
            className="blog-modern-content"
            dangerouslySetInnerHTML={{ __html: post.fullContent }}
          />

          <div className="page-end">
            <Link to="/blogs" className="back-btn">← Back to All Blogs</Link>
          </div>
        </div>
      </div>

    </div>
  );
};

export default BlogDetail;
